import React from 'react';

import CustomError from './Error';

const Error404 = () => (
    <CustomError errorNumber={404} errorText="A página não foi encontrada..." title="Página não encontrada" />
);

export default Error404;
